import {
  IconChartBar,
  IconDatabase,
  IconLayoutDashboard,
  IconMoustache,
  IconShirt,
  IconUserSquare,
} from '@tabler/icons-react'
import { Command } from 'lucide-react'
import { type SidebarData } from '../types'

export const sidebarData: SidebarData = {
  user: {
    name: 'Admin',
    email: 'admin@cdn',
    avatar: '/avatars/shadcn.jpg',
  },
  teams: [
    {
      name: 'Ender CDN',
      logo: Command,
      plan: 'Admin',
    },
  ],
  navGroups: [
    {
      title: 'Tổng quan',
      items: [
        {
          title: 'Bảng điều khiển',
          url: '/',
          icon: IconLayoutDashboard,
        },
        {
          title: 'Phân tích',
          url: '/analytics',
          icon: IconChartBar,
        },
      ],
    },
    {
      title: 'Thư viện',
      items: [
        {
          title: 'Quần áo',
          url: '/clothes',
          icon: IconShirt,
        },
        {
          title: 'Overlay',
          url: '/overlays',
          icon: IconMoustache,
        },
        {
          title: 'Ma-nơ-canh',
          url: '/mannequins',
          icon: IconUserSquare,
        },
      ],
    },
    {
      title: 'Hệ thống',
      items: [
        {
          title: 'Cài đặt',
          url: '/settings',
          icon: IconDatabase,
        },
      ],
    },
  ],
}
